import controller from './menu-dropdown.controller';
import template from './menu-dropdown.view.html';

let MenuDropdownComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<',
    menu : '<'
  }
};

export default MenuDropdownComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/menu-dropdown/menu-dropdown.component.js
 **/